/**
 * Component for remembering whether or not its children has been presented to a customer
 *
 * @param children - children of the component
 * @param persistKey - key of the value to persist
 * @param persistStorage - location where to persist the value
 */

import { useEffect } from 'react';

type PersistProps = {
  children: React.ReactNode;
  persistKey: string;
  persistStorage: 'local' | 'session' | 'none';
};

export const Persist = ({ children, persistKey, persistStorage }: PersistProps) => {
  const getStorage = () => {
    if (persistStorage === 'local') return window.localStorage;
    if (persistStorage === 'session') return window.sessionStorage;
    return null;
  };

  const storage = getStorage();
  const hasSeenChild = storage?.getItem(persistKey);

  useEffect(() => {
    if (storage) {
      storage.setItem(persistKey, 'true');
    }
  }, [storage, persistKey]);

  if (hasSeenChild) return null;
  return children;
};
